import React, { useState } from "react";
import Heading from "../../../component/Heading/Heading";
import "../../../styles/pages/billing/paymentHistory.scss";
import Subscription from "./Subscription";
import History from "./History";
import CommonTabs from "../../../component/tabs/Tabs";
import { useTranslation } from "react-i18next";

const tabs = [
    { label: 'Subscription', translationKey: 'client_list_subscription' },
    { label: 'History', translationKey: 'payment_history_text' },
];

const content = [
    <Subscription />,
    <History />
];

const PaymentHistory = () => {
    const { t } = useTranslation();
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className="payment-history">
            <div className="payment-history-main-heading">
                <Heading text={t("payment_history")} className="payment-heading" />
            </div>
            <div className="payment-history-border">
                <CommonTabs
                    value={value}
                    onChange={handleChange}
                    tabs={tabs}
                    content={content}
                />
            </div>
        </div>
    )
}

export default PaymentHistory;